"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonTable = void 0;
const React = require("react");
const Pagination_1 = require("../Pagination");
const pagination_dots_1 = require("../Pagination/pagination-dots");
const Spinner_1 = require("../Spinner");
const table_body_1 = require("./table-body");
const table_header_1 = require("./table-header");
const constants_1 = require("../../utils/constants");
const table_type_1 = require("./table.type");
const BronsonTable = (props) => {
    const footerClass = props.config.footerClass
        ? props.config.footerClass
        : 'u-4/12';
    const [hideHeaders] = React.useState(false);
    const [currentPageSize, setCurrentPageSize] = React.useState(props.config.currentPageSize);
    const verifyProps = () => {
        if (!props.config.data ||
            props.config.data === undefined ||
            props.config.data === null) {
            return false;
        }
        if (!props.config.headers ||
            props.config.headers === undefined ||
            props.config.headers === null) {
            return false;
        }
        return true;
    };
    const getId = () => {
        if (props.config.tableId) {
            return props.config.tableId;
        }
        else
            return '';
    };
    const getTableWrapperClassTransformers = () => {
        if (props.config.tableWrapperClassTransformers !== undefined) {
            return props.config.tableWrapperClassTransformers;
        }
        return '';
    };
    const forceScroll = () => {
        let tableWrapperStyle = {};
        if (props.config.forceScroll) {
            tableWrapperStyle = {
                overflowX: 'scroll',
            };
        }
        if (props.config.additionalStyles) {
            const { additionalStyles } = props.config;
            Object.keys(additionalStyles).forEach((style) => {
                tableWrapperStyle = Object.assign(Object.assign({}, tableWrapperStyle), { [style]: additionalStyles[style] });
            });
        }
        return tableWrapperStyle;
    };
    const selectPageSize = (e) => {
        setCurrentPageSize(+e.target.value);
        if (props.config.onPageSizeChange) {
            props.config.onPageSizeChange(+e.target.value);
        }
    };
    const spinnerConfig = {
        showSpinner: true,
        spinnerWrapperClassModifier: `c-spinner--section${props.config.spinnerClass ? ` ${props.config.spinnerClass}` : ''}`,
    };
    const renderTableFooter = () => {
        if (props.config.tableFooter !== undefined) {
            return React.createElement("tfoot", null, props.config.tableFooter);
        }
        return React.createElement(React.Fragment, null);
    };
    const renderPagination = () => {
        if (props.config.paginationEnabled !== undefined &&
            props.config.paginationEnabled !== false &&
            props.config.paginationConfig &&
            props.config.tableState !== table_type_1.BronsonTableState.error) {
            if (props.config.paginationDots) {
                return (React.createElement("div", { id: 'dh-bronson-table-pagination-dots', className: 'o-layout__item u-text-center  u-6/12 u-3/6@m u-1/1@s u-mv-small@s' },
                    React.createElement(pagination_dots_1.BronsonPaginationDots, { config: props.config.paginationConfig })));
            }
            else {
                return (React.createElement("div", { id: 'dh-bronson-table-pagination', className: 'o-layout__item u-text-center  u-6/12 u-3/6@m u-1/1@s u-mv-small@s' },
                    React.createElement(Pagination_1.BronsonPagination, { config: props.config.paginationConfig })));
            }
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    const renderFooterToolBar = () => {
        const pages = props.config.pagesSize
            ? props.config.pagesSize
            : [];
        return (React.createElement("div", { className: 'o-layout o-layout--flush' },
            props.config.pageSizeEnabled !== false && (React.createElement("div", { id: 'dh-bronson-table-page-size', className: 'o-layout__item  u-2/12 u-1/6@m u-1/1@s' }, pages.length > constants_1.zero && (React.createElement("div", { className: 'c-input  c-input--select' },
                React.createElement("select", { title: 'Selecciona cuantos resultados quieres mostrar a la vez.', className: 'c-input__input  ', name: 'dh-bronson-page-size-dp', id: 'dh-bronson-page-size-dp', defaultValue: currentPageSize, onChange: selectPageSize }, pages.map((page, index) => {
                    return (React.createElement("option", { key: index, value: page }, page));
                })))))),
            renderPagination(),
            props.config.customFooterTool !== undefined && (React.createElement("div", { id: 'dh-bronson-table-custom-tool', className: `o-layout__item ${footerClass} u-2/6@m u-1/1@s u-float-right` }, props.config.customFooterTool ? (props.config.customFooterTool) : (React.createElement(React.Fragment, null))))));
    };
    const renderTable = () => {
        if (props.config.tableState === table_type_1.BronsonTableState.isLoading) {
            return React.createElement(Spinner_1.BronsonSpinner, { config: spinnerConfig });
        }
        else {
            return (React.createElement("div", { className: `c-table-wrapper ${getTableWrapperClassTransformers()}`, style: forceScroll() },
                React.createElement("table", { id: getId(), "data-id": getId() },
                    props.config.data.length > constants_1.zero &&
                        props.config.tableState ===
                            table_type_1.BronsonTableState.done && (React.createElement(table_header_1.BronsonTableHeader, { headers: props.config.headers, sortFunction: props.config.onSort, headersState: props.config.headersState, setHeadersState: props.config.setHeadersState, hideHeaders: hideHeaders })),
                    React.createElement(table_body_1.BronsonTableBody, { data: props.config.data, headers: props.config.headers, tableState: props.config.tableState }),
                    renderTableFooter())));
        }
    };
    if (verifyProps())
        return (React.createElement("div", null,
            renderTable(),
            renderFooterToolBar()));
    else
        return (React.createElement("div", { className: 'c-error-message' }, "Ocurrio un error al intentar construir la tabla"));
};
exports.BronsonTable = BronsonTable;
